import Axios from "axios";
import {
    SET_WORK_ORDER_ACTIVITY_LOG_LIST,
    UNSET_WORK_ORDER_ACTIVITY_LOG_LIST,
} from "@/store/mutation-types";
import { getSalesWorkOrderActivityLog, saveSalesWorkOrderActivityLog } from "@/store/api";

// initial state
const state = {
    getSalesWorkOrderActivityLog: [],
    editingSalesWorkOrderActivityLog: null,
};

const getters = {
    getSalesWorkOrderActivityLog(state) {
        return state.getSalesWorkOrderActivityLog;
    },
    getEditingSalesWorkOrderActivityLog: (state) => state.editingSalesWorkOrderActivityLog,
};

const mutations = {
    [SET_WORK_ORDER_ACTIVITY_LOG_LIST](state, data) {
        state.getSalesWorkOrderActivityLog = data;
    },
    [UNSET_WORK_ORDER_ACTIVITY_LOG_LIST](state) {
        state.getSalesWorkOrderActivityLog = [];
    },
    setEditingSalesWorkOrderActivityLog(state, workorder) {
        state.editingSalesWorkOrderActivityLog = workorder;
    },
};

const actions = {
    saveSalesWorkOrderActivityLog({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        const saveSalesWorkOrderLogbyId = `${saveSalesWorkOrderActivityLog}/${data.workorder_id}`
        return new Promise((resolve, reject) => {
        Axios.post(saveSalesWorkOrderLogbyId, data)
            .then(function (response) {
                console.log(response);
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

    getSalesWorkOrderActivityLog({ commit }, data) {
        return new Promise((resolve, reject) => {
        Axios.post(getSalesWorkOrderActivityLog, data)
            .then(function (response) {
                commit("SET_WORK_ORDER_ACTIVITY_LOG_LIST", response.data.data);
                resolve(response);
            })
            .catch(function (error) {
                commit("UNSET_WORK_ORDER_ACTIVITY_LOG_LIST");
                reject(error);
            })
            .then((always) => {});
        });
    },

    // getSalesWorkOrderById({ commit }, data) {
    //     const getSalesWorkOrderById = `${getSalesWorkOrderActivityLog}/${data}`;
    //     commit("SET_LOADING", { color: "primary" });
    //     return new Promise((resolve, reject) => {
    //         Axios.get(getSalesWorkOrderById)
    //         .then((response) => {
    //             resolve(response.data.code);
    //         })
    //         .catch((error) => {
    //             reject(error);
    //         });
    //     });
    // },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
